import AppUser from '../../application/domain/entities/appUser';
import UserDto from '../dto/userDto';

export function mapUserDtoToAppUser(dto: UserDto): AppUser {
    return new AppUser(
        dto.appUserId,
        dto.accountId,
        dto.vtAppUserId,
        dto.email,
        dto.firstName,
        dto.lastName,
        dto.contactPhone,
        dto.jobTitle,
        dto.vtAppRole,
        dto.createdAt,
        dto.updatedAt
    );
}
